import { useContext, useMemo } from "react"
import { matchPath, useLocation } from "react-router-dom"
import { FILTERS_CUSTOMIZATIONS } from "../constants/filters"
import { FilterSettings, UseFiltersState } from "../states/filters"
import { useSelector } from "react-redux"
import { RootState } from "../../mp-core/redux/store"
import { ReportingContext } from "../providers/ReportingProvider"

export const useViewFilters = (filters: UseFiltersState): UseFiltersState => {
  const location = useLocation()

  const { filtersByRoute } = useContext(ReportingContext)

  const user = useSelector((state: RootState) => state.users.testUser)

  const [viewState, viewSettings] = useMemo(() => {
    let settings: FilterSettings = {}
    const viewName = Object.keys(filtersByRoute).find(filterMatch =>
      matchPath(location.pathname, { path: filterMatch, exact: true })
    )
    const filtersByViewWithSettings = FILTERS_CUSTOMIZATIONS[viewName]
    settings =
      filtersByViewWithSettings?.["ALL"] ??
      filtersByViewWithSettings?.[user.role] ??
      filtersByViewWithSettings?.["DEFAULT"] ??
      {}
    const filtersByView = filtersByRoute[viewName ?? "default"]

    // TODO: need to apply filtersByViewWithSettings if roles have extra filters
    const state =
      Object.fromEntries(
        Object.entries(filters.state).filter(([filter]) =>
          filtersByView.includes(filter)
        )
      ) ?? {}

    return [state, settings]
  }, [location.pathname, filters.state, user.role, filtersByRoute])

  return {
    ...filters,
    state: viewState,
    stateSettings: viewSettings
  }
}
